import { render } from "./file-uploader.html?vue&type=template&id=aea0f2f8&scoped=true&ts=true&external"
import script from "./file-uploader.ts?vue&type=script&lang=ts&external"
export * from "./file-uploader.ts?vue&type=script&lang=ts&external"

import "./file-uploader.scss?vue&type=style&index=0&id=aea0f2f8&scoped=true&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aea0f2f8"]])

export default __exports__